import React, { Component } from 'react';
import '../../inc/genstyle.css';
import DataTable from "react-data-table-component";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import INA from './ifragmentna';
import Popup from '../../inc/popup';
import '../../inc/popup.css'
import DateTimeFormats from '../../inc/date-time-format';

import ISExtDriveDetail from './iextdrive-detail';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[47];
const TopNavBar = [
  { id: 0, title: "My Drive", value: "mydrive" },
  { id: 1, title: "Shared to External", value: "sharedtoexternal" },
  { id: 2, title: "Shared to Anyone", value: "sharedtoanyonewithlink" },
];
class ISExtDrive extends Component {
  constructor(props) {
    super(props);
    this.state = {
        stTitle: '',
        pageShow: '10',
        keyword: '',
        styleTb: 'table',
        driveData: [],
        columnsData: [],
        data_tab: TopNavBar,
        stPopTitle: '',
        isOpen: false,
        otherContent: '',
        defTabIndex: 0,
        pending: true
    };
    this.loadData = this.loadData.bind(this);
    this.handleSelectTab = this.handleSelectTab.bind(this);
  }
  togglePopClose() {
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: false,
      }
    })
  }  
 
  urlview(used,id,action) {
    var stPopTitle = "";
    if(used === 'Singapore') { stPopTitle = action+" Singapore Licence"; }
    else if(used === 'Malaysia') { stPopTitle = action+" Malaysia Licence"; }
    else if(used === 'Indonesia') { stPopTitle = action+" Indonesia Licence"; }
    this.setState( prevState => {
      return {  
        ...prevState.stPopTitle, stPopTitle: stPopTitle,  
          ...prevState.isOpen2, isOpen2: true,
          ...prevState.otherContent, otherContent : '{"usageFor":"'+used+'","lictypeId":"'+id+'","action":"'+action+'"}'
      }
    })
  }
  
  
  handleSelectTab(idx) {
    this.loadData(idx);
  }
  loadData(tabindex) {
    const ActionCols = (row) => (
      <div className=" flex flex-row justify-center items-center">
        <MoreVertIcon
          className={`cursor-pointer hover:bg-gray-100`}
          size={40}
          onClick={this.urlview.bind(this, tabindex,row,'View')}
        />
      </div>
    );
    
    const columns = [
      {
        name: "Name",
        cell: (row) => row.name,
      },
      {
        name: "Type",
        cell: (row) => row.mimeType,
      },
      {
        name: "Modified Time",
        cell: (row) => DateTimeFormats(Math.round(new Date(row.modifiedTime).getTime()/1000),"datetime-short"),
      },
      {
        name: "Action",
        ignoreRowClick: true,
        grow: 0,
        cell: ActionCols,
      },
    ];
    

    /* ========= */
    document.getElementById('loading-area').style.display = 'block'; 
    var data = {
      paramType : this.state.data_tab[tabindex].value
    };
    fetch(global.config.urlLink+"/sharedrive", {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Authorization': authKey,
      }, body : JSON.stringify(data)
  
    }).then((res) => res.json())
      .then((resJson) => {
          if (resJson.status === "200") {
            this.setState({
              driveData: resJson.values,
              columnsData: columns,
              pending: false
            })
          } else {
            console.log("error fetching status code");
          }
          document.getElementById('loading-area').style.display = 'none'; 
      }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  componentDidMount() {
    var  defindex = 0;
    this.setState({
      defTabIndex: defindex
    })
    this.loadData(defindex);
  }

  contentTabs(param) {
    
    return(<div>
              <div className="row-field mgT20">
              <DataTable
                data={this.state.driveData}
                columns={this.state.columnsData}
                dense
                pagination
                paginationPerPage={15}
                pointerOnHover
                customStyles={{
                  headRow: {
                    style: {
                      borderBottomWidth: "3px",
                      borderBottomStyle: "solid",
                      fontWeight: "bold",
                      backgroundColor: "#F5F6FA",
                      color: "#8A92A6",
                      fontSize: '12px'
                    },
                    denseStyle: {
                      minHeight: "50px",
                    },
                  },
                  rows: {
                    style: {
                      minHeight: "72px", // override the row height
                    },                    
                  },
                  cells: {
                    style: {
                      paddingLeft: "8px", // override the cell padding for data cells
                      paddingRight: "8px",
                      fontSize: '11px'
                    },
                  },
                }}
              />
              </div>
           </div>
    )
  }  

  render() {
    
      var  defindex = 0;
      return (
        <div className="main-container">
          <div  className="header-main"><IHeader/></div>
              <div className="flex-container">
                  <div className="sidebar-main"><ISidemenu/></div>
                  <div className="main-content">
                    <div className="stTitle">External Shared Drive</div>
                    {((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[2] === "ON") || (JSON.parse(localStorage.getItem('urole'))[3] === "ON") || (JSON.parse(localStorage.getItem('urole'))[4] === "ON"))? 
                    <div>
                      <div className="stIndiTitle">List of files on Google Drive that are shared outside the organization</div>
                      <div className="mgT30">
                          <Tabs defaultIndex={defindex} onSelect={this.handleSelectTab}>
                            <TabList className="tabs-class__tab-list">
                              {
                                
                                this.state.data_tab.map((item, j) => {
                                  return (
                                    <Tab id={j}  className="tabs-class__tab" disabledClassName="tabs-class__tab--disabled" selectedtabclassname="tabs-class__tab--selected">{item.title}</Tab>
                                  )
                                })
                              }
                            </TabList>
                            {   
                                this.state.data_tab.map((item2, k) => {
                                  return (
                                    <TabPanel className="tabs-class__tab-panel" selectedClassName="tabs-class__tab-panel--selected">{this.contentTabs(k)}</TabPanel>
                                  )
                                })
                            }
                            
                          </Tabs>
                        {/*</div>*/}
                      </div>
                      <div>
                              {this.state.isOpen && <Popup
                                content={<><ISExtDriveDetail/></>}
                                title={this.state.stPopTitle}
                                others={this.state.otherContent}
                                styles={"50%"}
                                handleClose={this.togglePopClose.bind(this)}
                              />}
                        </div>
                    </div>
                    :   
                    <div><INA/></div>
                    }
                  </div>
              </div>
              <div id="loading-area" className="divHide loading"></div>
        </div>
      );
    
  }
}
 
export default ISExtDrive;